import { normalizeProductStockUnit } from 'src/constants/productStockUnits';

/** Cart lines that share the same product `id` (POS, accounting cart, etc.). */
export type IdQtyLine = { id: number; quantity: number };

/** After editing one cart line, total qty for that product id (all lines). */
export function projectedCartQtyForProductLine(
  lines: IdQtyLine[],
  lineIndex: number,
  newQuantityForLine: number
): number | null {
  const line = lines[lineIndex];
  if (!line) return null;
  const productId = line.id;
  const lineBefore = line.quantity;
  const sumSameId = lines
    .filter((p) => p.id === productId)
    .reduce((acc, p) => acc + p.quantity, 0);
  return sumSameId - lineBefore + newQuantityForLine;
}

export function isDiscreteProductStockUnit(stockUnit?: string | null): boolean {
  return normalizeProductStockUnit(stockUnit) === 'un';
}

export function roundPosSaleQuantity(
  qty: number,
  stockUnit?: string | null
): number {
  const n = Number(qty);
  if (!Number.isFinite(n)) return 0;
  if (isDiscreteProductStockUnit(stockUnit)) {
    return Math.round(n);
  }
  return Math.round(n * 100) / 100;
}

export function minPosSaleQuantity(stockUnit?: string | null): number {
  return isDiscreteProductStockUnit(stockUnit) ? 1 : 0.01;
}

export function posSaleQuantityStep(stockUnit?: string | null): number {
  return isDiscreteProductStockUnit(stockUnit) ? 1 : 0.01;
}
